module.exports = __webpack_public_path__ + "lato-regular-webfont.a7b2d4f6327a975fdf30.svg";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/fonts/lato-regular-webfont.svg
// module id = ../../../../../resources/fonts/lato-regular-webfont.svg
// module chunks = styles